import { AlertMenuProps } from "@/component/Alert/AlertMenu/AlertMenu"
import { getContents, getInputText, getSelectText, getText } from "@/component/Alert/AlertMenu/alertMenuUtils"
import { DhbNavBar } from "@/component/PageComponentMobile/head"
import { ReportConfig } from "@/component/common/report/report"
import { CustomReportConfig } from "@/component/common/report/reportConfigModel"
import React from 'react'
import styled from "styled-components"
import { List } from 'antd-mobile'


type AlertMenuType = Required<CustomReportConfig>['alertMenu']


interface AlertMenuItemMobileProps {
  menuItem: AlertMenuType['menu'][number]
  variable: AlertMenuType['variable']
}

const AlertMenuItemMobile = (props:AlertMenuItemMobileProps)=>{
  const { menuItem, variable } = props
  let contents = React.useMemo(()=>{
    return getContents(menuItem.content);
  },[menuItem.content, variable])
  let contentString = contents.map(item=>{
    let variableInfo = variable[item]
    if(!variableInfo){
      return getText(item)
    }
    if(variableInfo.display_type == 'select'){
      return getSelectText(variableInfo)
    }
    if(variableInfo.display_type == 'input'){
      return getInputText(variableInfo)
    }
    return ''
  }).join('')

  return <div className="text">{ contentString }</div>
}




const AlertMobileView = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  .alert-menu-item{
    /* background-color: rgba(0,0,0,0.04); */
    .text{
      font-size: 14px;
    }
  }
  .list{
    flex: 1;
    overflow: auto;
  }
`




interface AlertMenuPropsMobile extends Pick<AlertMenuProps,'menuItem'|'onChangeAlertMenuItem'> {
  reportConfig: ReportConfig
  onBack():void
}


export const AlertMenuMobile = (props:AlertMenuPropsMobile)=>{
  const {  menuItem,reportConfig,onChangeAlertMenuItem} = props
  const alertMenu = reportConfig.config.report_config.alertMenu
  const {variable} = alertMenu || {}
  if(!alertMenu || !variable){
    return null
  }
  const { menu } = alertMenu
  return <AlertMobileView>
    <DhbNavBar
      title={ reportConfig.config.report_name }
      onBack={props.onBack}
    />
    <List className="list">
      {menu.map(item => {
        let isActive = menuItem?.id == item.id
        return <List.Item className={`alert-menu-item ${isActive ? 'active' : ''}`} key={item.id} onClick={() => onChangeAlertMenuItem(item)}>
          <div className="name">{item.key_name}</div>
          <AlertMenuItemMobile variable={variable} menuItem={item} />
        </List.Item>
      })}
    </List>
    
  </AlertMobileView>
}



